import { useErrorInlineNotification } from '@/components/ErrorInlineNotification';
import { Container } from '@/features/ip_address_whitelists/components/Container/Container';
import { IpAddressWhitelistListView } from '@/features/ip_address_whitelists/IpAddressWhitelistList/IpAddressWhitelistListView';
import classnames from 'classnames/bind';
import { FC, memo, useState } from 'react';
import { IpAddressRestriction } from './IpAddressRestriction/IpAddressRestriction';
import styles from './ipAddressWhitelists.module.scss';

const cx = classnames.bind(styles);

export type Props = {
  officeId: string;
};

export const IpAddressWhitelists: FC<Props> = memo(({ officeId }) => {
  const [isEditingRestrict, setIsEditingRestrict] = useState(false);
  const [isEditingWhitelist, setIsEditingWhitelist] = useState(false);
  const [isWhitelistEmpty, setIsWhitelistEmpty] = useState(true);

  const [
    { setError: setInlineError },
    ErrorContextHolder,
    ErrorInlineNotificationProvider,
  ] = useErrorInlineNotification();

  return (
    <Container>
      <ErrorInlineNotificationProvider value={setInlineError}>
        {ErrorContextHolder}
        <div className={cx('stack')}>
          <IpAddressRestriction
            isEditingRestrict={isEditingRestrict}
            onIsEditingRestrictChange={setIsEditingRestrict}
            isRestrictionEditLocked={isEditingWhitelist}
            isWhitelistEmpty={isWhitelistEmpty}
            setInlineError={setInlineError}
            officeId={officeId}
          />
          <IpAddressWhitelistListView
            isEditingRestrict={isEditingRestrict}
            onIsEditingWhitelistChange={setIsEditingWhitelist}
            onIsEmptyChange={setIsWhitelistEmpty}
            setInlineError={setInlineError}
            officeId={officeId}
          />
        </div>
      </ErrorInlineNotificationProvider>
    </Container>
  );
});
IpAddressWhitelists.displayName = 'IpAddressWhitelists';
